import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import Caption from "../Widgets/Caption"
import Quote from "../Widgets/Quote"
import RichTextContainer from "../Widgets/RichTextContainer"
import Link from "../Widgets/Link"
import filter from "lodash/filter"
import ShopTheLookLink from "../ShopThLook/ShopTheLookLink"
import Carousel from './Carousel'
import CentredContentContainer from "../Widgets/CentredContentContainer"

const MAX_IMAGE_WIDTH = 420;

class ImageWithContent extends PureComponent {

    render() {
        const {classes, item} = this.props;
        const {image, video, items, quote, quote_attribution, caption, text, button_link, shop_the_look_title, shopItems} = item;

        const content = filter( [
            quote && <Quote key="quote" bodyClassName={classes.quoteBody} quote={quote} quote_attribution={quote_attribution}/>,
            text && <RichTextContainer key="content" content={text} removeBottomMargin={!button_link || !button_link.url} />,
            button_link && button_link.url && <Link className={classes.link} key="link" link={button_link} />,
        ], x => x)

        const hasShopItems = shopItems && shopItems.length > 0;
        const shopTheLookImage = hasShopItems && ((image && image.desktop) || (video && video.image.desktop))

        return <section>
            <CentredContentContainer className={classes.container}>
                <div className={classes.gridWrapper}>
                    <div className={classes.column}>
                        <div className={classes.imageContainer}>
                            {!(items && items.length > 0) && (image || video) &&
                            <div className={classes.image}>
                                {(image || video) &&
                                <ImageOrVideo images={image} link={!hasShopItems && button_link}
                                            video={video}
                                                sizes={`min-width: ${MAX_IMAGE_WIDTH}px ${MAX_IMAGE_WIDTH}px, 100vw`}
                                                caption={caption}>
                                    {hasShopItems && <ShopTheLookLink title={shop_the_look_title} shopItems={shopItems} image={{desktop: shopTheLookImage}}/>}
                                </ImageOrVideo>
                                }
                                {caption && <Caption key="caption" caption={caption}></Caption>}
                            </div>
                            }
                            {items && items.length > 0 &&
                            <div className={classes.image}>
                                <Carousel prevNextContainer={props => <div className={classes.carouselPrevNextContainer}>{props.children}</div>}
                                        items={items.filter(x => x.image).map((i, index) =>(
                                            <div key={index} className={classes.flikityCell}>
                                                <ImageOrVideo images={i.image}
                                                            video={i.video}
                                                                link={!(i.shopItems && i.shopItems.length > 0) && button_link}
                                                                sizes={`min-width: ${MAX_IMAGE_WIDTH}px ${MAX_IMAGE_WIDTH}px, 100vw`}
                                                                caption={i.caption}>
                                                    {i.shopItems && i.shopItems.length > 0 &&
                                                    <ShopTheLookLink title={shop_the_look_title} shopItems={i.shopItems} image={{desktop: i.image.desktop}}/>
                                                    }
                                                </ImageOrVideo>
                                                {i.caption && <Caption key="caption" caption={i.caption}></Caption>}
                                            </div>
                                            )
                                        )}/>
                            </div>
                            }
                        </div>
                    </div>
                    <div className={classes.column}>
                        <div className={classes.contentContainer}>
                            {content}
                        </div>
                    </div>
                </div>
            </CentredContentContainer>
        </section>
    }
}

export default injectSheet((theme) => (
    {
        gridWrapper: {
            display: "block",
            margin: 0,
            [theme.breakpoint("tablet")]: {
                display: "flex",
                margin: '-1%',
                flexDirection: ({item: {image_location}}) => image_location === 'Right' ? "row-reverse" : "row",
            }
        },
        column: {
            flexBasis: "50%",
            margin: 0,
            [theme.breakpoint("tablet")]: {
                padding: '1%'
            },
            '&:last-child': {
                [theme.breakpoint("tablet")]: {
                    padding: ({item: {image_location}}) => image_location === 'Right' ? '0 2% 0 1%' : '0 1% 0 2%'
                }
            }
        },
        imageContainer: {
            maxWidth: MAX_IMAGE_WIDTH,
            width: '100%',
            margin: [0, 'auto', theme.spacing.small],
            [theme.breakpoint("tablet")]: {
               margin: ({item: {image_location}}) => image_location === 'Right' ? '0 auto 0 0' : '0 0 0 auto'
            }
        },
        contentContainer: {
            maxWidth: MAX_IMAGE_WIDTH,
            margin: [0, 'auto'],
            height: '100%'
        },
        image: {
            display: "flex",
            flexDirection: "column-reverse",
            [theme.breakpoint("tablet")]: {
                flexDirection: "column",
            },
        },
        quoteBody: {
            maxWidth: "100%",
            padding: 0,
            margin: `0 0 ${theme.spacing.small} 0`,
            [theme.breakpoint("tablet")]: {
                margin: `${theme.spacing.small} 0`,
            },
        },
        link: {
            display: 'inline-block'
        },
        flikityCell: {
            width: '100%',
            marginRight: 20
        },
        carouselPrevNextContainer: {
        }
    }
))(ImageWithContent)



// WEBPACK FOOTER //
// ./src/components/Article/ImageWithContent.js